module.exports = __webpack_public_path__ + "media/images/icon-reveal-white-38dcd56c74c26b24bfe27b73dad0b02a.svg";